import {match} from 'ts-pattern';

import type {FeatureResponseBody} from '@dms/api/new-vehicle';
import i18n from '@dms/i18n';

import type {RuleValues} from './EquipmentAuthoring';

const tValues = (key: string, options: {defaultValue: string; [value: string]: string | number}) =>
  i18n.t(key, options);

export const ruleSentence = (values: RuleValues, features: FeatureResponseBody[]) => {
  const name = (id: string) => features.find((item) => item.id === id)?.name ?? id;
  const source = name(values.sourceFeatureId);
  const targets = values.targetFeatureIds.map(name).join(', ');
  return match(values.type)
    .with('requires', () =>
      tValues('entity.newVehicle.rules.requiresSentence', {
        defaultValue: '{source} requires {targets} — add it first',
        source,
        targets,
      })
    )
    .with('excludes', () =>
      tValues('entity.newVehicle.rules.excludesSentence', {
        defaultValue: '{source} cannot be combined with {targets}',
        source,
        targets,
      })
    )
    .with('autoAdd', () =>
      tValues('entity.newVehicle.rules.autoAddSentence', {
        defaultValue: 'Adds {targets} when {source} is selected',
        source,
        targets,
      })
    )
    .exhaustive();
};
